import { render, staticRenderFns } from "./ReturnDish.vue?vue&type=template&id=0a4d75fc&scoped=true&"
import script from "./ReturnDish.vue?vue&type=script&lang=js&"
export * from "./ReturnDish.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDish.vue?vue&type=style&index=0&id=0a4d75fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d75fc",
  null
  
)

export default component.exports